import day_1 from '../../../assets/images/dayton1.webp';
import day_5 from '../../../assets/images/dayton5.webp';
import day_6 from '../../../assets/images/dayton6.webp';
import day_3 from '../../../assets/images/dayton3.webp';
import day_2 from '../../../assets/images/dayton2.webp';

const slides = [
    {
        id: 1,
        image: day_1,
    },
    {
        id: 2,
        image: day_5,
    },
    {
        id: 3,
        image: day_6,
    },
    {
        id: 4,
        image: day_3,
    },
    {
        id: 5,
        image: day_2,
    },
]

export default slides